"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollDirection = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = require("react");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const libs_polyfills_1 = require("@hotelplan/libs.polyfills");
const libs_utils_1 = require("@hotelplan/libs.utils");
var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection["VERTICAL"] = "vertical";
    ScrollDirection["HORIZONTAL"] = "horizontal";
})(ScrollDirection || (exports.ScrollDirection = ScrollDirection = {}));
function useOnScrolledReach(callback, options = {}) {
    const { direction = ScrollDirection.VERTICAL, threshold = 20, timeout = 50, enable = true, } = options;
    const [el, setEl] = (0, react_1.useState)(null);
    const ref = (0, react_1.useRef)(null);
    const elRef = (0, react_1.useMemo)(() => ({
        set current(nextEl) {
            setEl((ref.current = nextEl));
        },
        get current() {
            return ref.current;
        },
    }), []);
    const enableRef = (0, libs_hooks_react_1.useSelfUpdatingRef)(enable);
    const callbackRef = (0, libs_hooks_react_1.useSelfUpdatingRef)(callback);
    const callbackExistence = typeof callback === 'function';
    (0, react_1.useEffect)(() => {
        if (!callbackExistence || !enable || !el || !libs_utils_1.isBrowser) {
            return;
        }
        const onScroll = (0, throttle_1.default)(() => {
            var _a;
            // prevent throttle call after finished effect
            if (!enableRef.current) {
                return;
            }
            const elRect = el.getBoundingClientRect();
            const elSize = elRect[direction === ScrollDirection.VERTICAL ? 'height' : 'width'];
            const scrollPosition = el[direction === ScrollDirection.VERTICAL ? 'scrollTop' : 'scrollLeft'];
            const scrollSize = el[direction === ScrollDirection.VERTICAL
                ? 'scrollHeight'
                : 'scrollWidth'];
            const scrollRest = scrollSize - (scrollPosition + elSize);
            if (scrollRest <= threshold) {
                (_a = callbackRef.current) === null || _a === void 0 ? void 0 : _a.call(callbackRef);
            }
        }, timeout);
        el.addEventListener('scroll', onScroll, libs_polyfills_1.optionsWithPassive);
        return () => {
            el.removeEventListener('scroll', onScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [el, callbackExistence, direction, enable, threshold, timeout]);
    return elRef;
}
exports.default = useOnScrolledReach;
//# sourceMappingURL=useOnScrolledReach.js.map